/**
 * Aspect — Per-user apartment library (browser localStorage MVP)
 */

const KEY = "aspect:portal:apartments";

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

function userKey(email) {
  return String(email ?? "")
    .trim()
    .toLowerCase();
}

/** @returns {object[]} */
export function listApartments(email) {
  const uk = userKey(email);
  return [...(readAll()[uk] ?? [])].sort((a, b) => (b.updatedAt ?? 0) - (a.updatedAt ?? 0));
}

export function getApartment(email, id) {
  return listApartments(email).find((a) => a.id === id) ?? null;
}

function slugId() {
  return `apt_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
}

export function createApartment(email, { name, source = "demo" }) {
  const uk = userKey(email);
  const map = readAll();
  const list = map[uk] ?? [];
  const now = Date.now();
  const apt = {
    id: slugId(),
    name: String(name ?? "Untitled apartment").trim() || "Untitled apartment",
    source,
    status: "draft",
    visibility: "private",
    tourId: null,
    tourUrl: null,
    rooms: source === "demo" ? 1 : 0,
    area: source === "demo" ? 48 : null,
    thumbnail: null,
    createdAt: now,
    updatedAt: now,
  };
  list.unshift(apt);
  map[uk] = list;
  writeAll(map);
  return apt;
}

export function updateApartment(email, id, patch) {
  const uk = userKey(email);
  const map = readAll();
  const list = map[uk] ?? [];
  const i = list.findIndex((a) => a.id === id);
  if (i < 0) return null;
  list[i] = { ...list[i], ...patch, updatedAt: Date.now() };
  map[uk] = list;
  writeAll(map);
  return list[i];
}

export function deleteApartment(email, id) {
  const uk = userKey(email);
  const map = readAll();
  const list = (map[uk] ?? []).filter((a) => a.id !== id);
  map[uk] = list;
  writeAll(map);
}

export function publishApartment(email, id, tourId, tourUrl) {
  return updateApartment(email, id, {
    status: "published",
    tourId,
    tourUrl,
    visibility: "public",
    publishedAt: Date.now(),
  });
}

export function setVisibility(email, id, visibility) {
  const apt = updateApartment(email, id, {
    visibility: visibility === "public" ? "public" : "private",
    status: visibility === "public" ? "published" : "draft",
  });
  return apt;
}
